import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import ThreeDSAuthenticationData from './threeDSAuthenticationDataWeb';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='token' subtitle='string' label='Required' mdxType="Item">
      <p>{`The payment instrument token you can use to `}<a parentName="p" {...{
          "href": "https://primer.io/docs/api/api-reference/payments-api/create-payment"
        }}>{`create a payment request`}</a>{` from your backend.`}</p>
    </Item>
    <Item title='analyticsId' subtitle='string' mdxType="Item">
      <p>{`An unique identifier for the payment instrument token.`}</p>
    </Item>
    <Item title='paymentInstrumentData' subtitle='PaymentInstrumentData' mdxType="Item">
      <p>{`Additional information about the payment instrument.
Depending on the payment method type, only some of the following properties are present on the object.`}</p>
      <Group summary='Properties' mdxType="Group">
        <Item title='paymentMethodConfigId' subtitle='string' mdxType="Item">
The identifier for the payment method configuration.
        </Item>
        <Item title='paymentMethodType' subtitle='string' mdxType="Item">
          <p>{`The type of the payment method used for the transaction, one of `}<a parentName="p" {...{
              "href": "/docs/sdk/web/2.x.x/constants/paymentMethodTypes"
            }}>{`PaymentMethodType`}</a>{`.`}</p>
        </Item>
        <Item title='sessionInfo' subtitle='SessionInfo' mdxType="Item">
Information about the session associated with the transaction.
        </Item>
        <Item title='first6Digits' subtitle='string' mdxType="Item">
The first six digits of the payment card.
        </Item>
        <Item title='last4Digits' subtitle='string' mdxType="Item">
The last four digits of the payment card.
        </Item>
        <Item title='expirationMonth' subtitle='string' mdxType="Item">
The expiration month of the payment card.
        </Item>
        <Item title='expirationYear' subtitle='string' mdxType="Item">
The expiration year of the payment card.
        </Item>
        <Item title='cardholderName' subtitle='string' mdxType="Item">
The name of the cardholder as it appears on the payment card.
        </Item>
        <Item title='network' subtitle='string' mdxType="Item">
The network associated with the payment card (e.g., Visa, Mastercard).
        </Item>
        <Item title='isNetworkTokenized' subtitle='string' mdxType="Item">
Indicates whether the payment card's network is tokenized.
        </Item>
        <Item title='binData' subtitle='BinData' mdxType="Item">
Information about the Bank Identification Number (BIN) of the payment card.
        </Item>
        <Item title='threeDSecureAuthentication' subtitle='ThreeDSAuthenticationData' mdxType="Item">
          <ThreeDSAuthenticationData mdxType="ThreeDSAuthenticationData" />
        </Item>
        <Item title='paypalBillingAgreementId' subtitle='string' mdxType="Item">
The identifier for a PayPal billing agreement, if applicable.
        </Item>
        <Item title='externalPayerInfo' subtitle='ExternalPayerInfo' mdxType="Item">
External information about the payer associated with the transaction.
        </Item>
        <Item title='shippingAddress' subtitle='ShippingAddress' mdxType="Item">
The shipping address for the transaction, if applicable.
        </Item>
        <Item title='klarnaCustomerToken' subtitle='string' mdxType="Item">
The customer token associated with Klarna payment, if applicable.
        </Item>
        <Item title='sessionData' subtitle='SessionData' mdxType="Item">
Additional data related to the session.
        </Item>
      </Group>
    </Item>
    <Item title='paymentInstrumentType' subtitle='PaymentInstrumentType' mdxType="Item">
      <p>{`The type of the payment instrument.`}</p>
      <p>{`Example of possible values (new values could be added as we add new payment methods):`}</p>
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`APPLE_PAY`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`CARD_OFF_SESSION_PAYMENT`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`GOOGLE_PAY`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`KLARNA_CUSTOMER_TOKEN`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`OFF_SESSION_PAYMENT`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`PAYMENT_CARD`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`PAYPAL_BILLING_AGREEMENT`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`PAYPAL_ORDER`}</inlineCode></li>
      </ul>
    </Item>
    <Item title='threeDSecureAuthentication' subtitle='ThreeDSAuthenticationData' mdxType="Item">
      <ThreeDSAuthenticationData mdxType="ThreeDSAuthenticationData" />
    </Item>
    <Item title='tokenType' subtitle='"SINGLE_USE" | "MULTI_USE"' mdxType="Item">
Whether this payment method token can be used only once or multiple times.
    </Item>
    <Item title='vaultData' subtitle='VaultData' mdxType="Item">
      <Group summary='Properties' mdxType="Group">
        <Item title='customerId' subtitle='string' mdxType="Item">
          <p>{`The `}<inlineCode parentName="p">{`customerId`}</inlineCode>{` associated to the payment method, if vaulted.`}</p>
        </Item>
      </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      